import { composeIO } from 'react-compose-io'
import { fieldsTipoParametroTransformacaoApiIO } from './FieldsTipoParametroTransformacaoApi.IO'
import FieldsTipoParametroTransformacaoApiView from './FieldsTipoParametroTransformacaoApi.View'

export const FieldsTipoParametroTransformacaoApi = composeIO(FieldsTipoParametroTransformacaoApiView, fieldsTipoParametroTransformacaoApiIO)
